module.exports = __webpack_public_path__ + "static/img/starpick.1033fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/starpick.png
// module id = H1li
// module chunks = 1